// src/components/Header.jsx
import { LogOut } from 'lucide-react'
import { User, Settings, ChevronDown, Sun, Moon, Menu } from './icons'
import { Menu as HeadlessMenu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { useTheme } from '../contexts/ThemeContext'
import { useNavigate } from 'react-router-dom'
import NotificationBell from './NotificationBell'
import AvisosNavegadorPrompt from './AvisosNavegadorPrompt';
import CommandSearchBar from './CommandSearchBar'
import { getRoleLabel } from '../utils/roleLabels'

export default function Header({ toggleSidebar }) {
    const { user, logout } = useAuth()
    const { darkMode, toggleDarkMode } = useTheme()
    const navigate = useNavigate()


    const handleLogout = () => {
        logout()
        navigate('/login')
    }

    const handleProfile = () => {
        navigate('/perfil')
    }

    const handleSettings = () => {
        navigate('/ajustes')
    }

    const getInitials = (user) => {
        if (user?.nombre && user?.apellido) {
            return `${user.nombre[0]}${user.apellido[0]}`.toUpperCase()
        }
        if (user?.username) {
            return user.username.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
        }
        return 'U'
    }

    // (eliminado helper formatTime sin uso)

    return (
        <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700 sticky top-0 z-40">
            <div className="max-w-full px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    {/* Logo y búsqueda */}
                    <div className="flex items-center space-x-2 sm:space-x-4 flex-shrink-0 mr-2">
                        {/* Botón de hamburguesa para móviles y tablets */}
                        <button
                            onClick={toggleSidebar}
                            className="md:hidden p-2 text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-lg transition-colors mr-1"
                            title="Abrir menú"
                        >
                            <Menu className="h-6 w-6" />
                        </button>
                        {/* Solo mostrar búsqueda para admin y soporte */}
                        {(user?.role === 'admin' || user?.role === 'soporte') && (
                            <div className="hidden md:block w-80 lg:w-96">
                                <CommandSearchBar />
                            </div>
                        )}
                    </div>

                    {/* Notificaciones y tema (el usuario se gestiona desde el sidebar) */}
                    <div className="flex items-center space-x-2 sm:space-x-3">
                        {/* Botón de tema */}
                        <button
                            onClick={toggleDarkMode}
                            className="p-2 text-gray-400 hover:text-gray-500 dark:text-gray-300 dark:hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 rounded-full transition-colors"
                            title={darkMode ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
                        >
                            {darkMode ? (
                                <Sun className="h-6 w-6" />
                            ) : (
                                <Moon className="h-6 w-6" />
                            )}
                        </button>

                        <NotificationBell />
                        <AvisosNavegadorPrompt />
                    </div>
                </div>
            </div>
        </header>
    )
}
